// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const StripeCluiTerminal: MarkdocTagRegistration = {
  tag: 'stripe-clui-terminal',
  component: 'StripeCluiTerminal',
};
